import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { Box, TableCell, TableRow, Typography } from "@mui/material";
import TableComponent from "../../../../component/Table/TableComponent";
import { formatAmount, formatGermanPercentage } from "../../../../helper/formatAmount";
import { getLiquiditätsbilanzList } from "../../../../services/customer-services/customerLiquiditätsbilanz";
import { useCommonContext } from "../../../../context/common";

const columns = [
    { field: "aktiva", headerName: "Aktiva ||", translationKey: 'liquiditätsbilanz_aktiva' },
    { field: "aktivaWert", headerName: "Aktiva Wert", translationKey: 'liquiditätsbilanz_aktivaWert' },
    { field: "passiva", headerName: "Passiva ||", translationKey: 'liquiditätsbilanz_passiva' },
    { field: "passivaWert", headerName: "Passiva Wert", translationKey: 'liquiditätsbilanz_passiva_wert' },
];

const LiquiditätsbilanzOne = () => {
    const { t } = useTranslation();
    const [liquidity, setLiquidity] = useState([]);
    const [totals, setTotals] = useState({});
    const { clientId } = useCommonContext();

    const getLiquiditätsbilanz = async () => {
        if (clientId) {
            const response = await getLiquiditätsbilanzList(clientId);
            if (response?.isSuccess) {
                setLiquidity([...response.data]);
                setTotals(response?.totals);
            }
            else {
                setLiquidity([]);
                setTotals({});
            }
        }
    }

    useEffect(() => {
        getLiquiditätsbilanz()
    }, [clientId]);

    const totalRatio =
        totals?.totalPassivaWert && totals.totalPassivaWert !== 0
            ? (totals.totalAktivaWert / totals.totalPassivaWert) * 100
            : 0;
            
    return (
        <div>
            <Typography variant="h6" sx={{ padding: "0" }}>
                {t('liquiditätsbilanz_tab_one')}
            </Typography>
            <div>
                <TableComponent
                    data={liquidity ?? []}
                    columns={columns}
                    className={'table-max-height'}
                    hidePagination={false}
                >
                    {liquidity?.map((row, rowIndex) => (
                        <TableRow key={rowIndex}>
                            <TableCell>{row.aktiva}</TableCell>
                            <TableCell>{formatAmount(row?.aktivaWert) + " €"}</TableCell>
                            <TableCell>{row?.passiva}</TableCell>
                            <TableCell>{formatAmount(row?.passivaWert) + " €"}</TableCell>
                        </TableRow>
                    ))}
                    {/* Add sum row */}
                    {
                        liquidity?.length !== 0 &&
                        <TableRow TableRow sx={{ fontWeight: 'bold' }}>
                            <TableCell>{t('common_sum')}</TableCell>
                            <TableCell>{formatAmount(totals?.totalAktivaWert) + " €"}</TableCell>
                            <TableCell>{t('common_sum')}</TableCell>
                            <TableCell>{formatAmount(totals?.totalPassivaWert) + " €"}</TableCell>
                        </TableRow>
                    }
                </TableComponent>
                <Box sx={{ display: 'flex', marginTop: "1.75rem" }}>
                    <Typography>
                        {t('liquiditätsbilanz_aktueller_insolvenzstatus')}
                        <Typography sx={{ fontSize: "1.5rem" }}>
                            {liquidity?.length !== 0 ? formatGermanPercentage(totalRatio) : '0,00'}%
                        </Typography>
                    </Typography>
                </Box>
            </div>
        </div >
    )
}

export default LiquiditätsbilanzOne